export enum DietaryTypes {
  GlutenFree,
  Vegan,
  Vegetarian,
  Organic,
  TransFatFree,
  DairyFree,
  GmoFree,
  SoyFree,
  NutFree,
  PeanutFree,
  EggFree,
  CholesterolFree,
  NitratesFree,
  NoSugarAdded,
  CornFree,
  AllergenFree
};